
/**
 * 返回一个随机字符， 从 'abacdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
 */
function getCode(): string {
    return 'abacdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.charAt(Math.ceil(Math.random() * 52))
}

function getCodes(len: number): string {
    let str = '';
    for (let i = 0; i < len; i++) {
        str += getCode()
    }
    return str
}

const sessionId = getCodes(32);

export default function getSessionId(): string {
    return sessionId;
}
